export default __webpack_public_path__ + "static/media/placeholder_store04-jp-web.9b404323.png";